import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsReviewTabClickedParams = {
  trail_id: number;
};

/**
 * User clicks on the review tab to view reviews of the trail.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsReviewTabClicked = ({ trail_id }: logTrailDetailsReviewTabClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details review tab clicked', { 'trail id': trail_id }, callback);
};

export default logTrailDetailsReviewTabClicked;
